import { useCallback } from 'react';

import { Button, useDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import { useAppDispatch, useLandingTracking } from 'shared/hooks';
import { setVisible } from 'shared/slices';

import * as styles from './styles.css';

import type { TButtonText } from 'shared/constants/tracking';

interface IActionLinkButtonProps {
  children: TButtonText;
}

export const ActionButton: React.FC<IActionLinkButtonProps> = ({ children }) => {
  const device = useDeviceType();
  const dispatch = useAppDispatch();
  const { trackButtonClick } = useLandingTracking();

  const size = device === 'phone' ? 'M' : 'L';

  const handleModalOpen = useCallback(() => {
    trackButtonClick(children);
    dispatch(setVisible(true));
  }, [children, dispatch, trackButtonClick]);

  return (
    <div className={clsx(styles['wrapper'], styles[device])}>
      <Button fullWidth size={size} onClick={handleModalOpen}>
        {children}
      </Button>
    </div>
  );
};
